<template>
    <div>
        <transition name="bounce" v-if="$vuetify.breakpoint.mdAndDown">
            <v-bottom-navigation
                v-if="hasBasketItems"
                :value="0"
                dark
                app
                color="white"
                fixed
                background-color="primary"
                grow
            >
                <v-btn :ripple="false" max-width="100%" @click="showBasket">
                    <span>Basket</span>
                    <v-icon :class="{rotate : rotate}">mdi-basket</v-icon>
                </v-btn>
            </v-bottom-navigation>
        </transition>
        <v-bottom-sheet v-model="basketVisible" scrollable v-resize="onResize">
            <BasketList :basket-visible.sync="basketVisible" />
        </v-bottom-sheet>
        <v-skeleton-loader
            v-if="!menu.length"
            type="menu-sections@2"
            :types="skeleton"
            loading
        />
    </div>
</template>

<script>
import { isEqual } from 'lodash-es';
import BasketList from '@/components/BasketList';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'TheFooter',

  components: {
    BasketList,
  },

  data: () => ({
    rotate: false,
    basketVisible: false,
    skeleton: {
      'menu-item': 'divider, list-item',
      'menu-sections': 'card-heading, menu-item@8',
    },
  }),

  computed: {
    navBasketVisible() {
      return this.$route.meta.basketVisible;
    },

    ...mapState({
      menu: (state) => state.menu.items,
    }),

    ...mapGetters([
      'basketItems',
      'hasBasketItems',
    ]),
  },

  watch: {
    // whenever question changes, this function will run
    basketItems(newBasketItems, oldBasketItems) {
      if (!isEqual(newBasketItems, oldBasketItems)) {
        this.rotate = true;
        setTimeout(() => {
          this.rotate = false;
        }, 500);
      }

      if (newBasketItems.length === 0) {
        this.basketVisible = false;
      }
    },

    navBasketVisible(newValue) {
      if (!newValue) {
        this.basketVisible = false;
      }
    },

    async basketVisible(newValue) {
      if (newValue) {
        await this.$router.push({ name: 'basket' });
      } else if (this.navBasketVisible) {
        // safari doesn't seem to like it going back twice too quickly,
        // i.e by removing last item in basket, triggers 2 backs, so delay this one.
        if (this.$route.name === 'basket'
          || this.$route.name === 'basket-select-item'
        ) {
          setTimeout(() => {
            this.$router.back();
          }, 100);
        }
      }
    },
  },

  methods: {
    showBasket() {
      this.basketVisible = true;
    },

    onResize() {
      if (this.$vuetify.breakpoint.mdAndUp && this.basketVisible) {
        this.$router.replace('/');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }

    50% {
      transform: scale(1.5);
    }

    100% {
      transform: scale(1);
    }
  }

  .rotate {
    animation: rotate .5s;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  .basket-btn {
    font-size: .75rem;

    .v-btn__content {
      flex-direction: column-reverse !important;
      font-size: .75rem;
      line-height: 1.2;
      text-transform: none;
    }
  }
</style>
